import { api } from "@/lib/api";

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js");
  } catch (e) {
    // SSR, unsupported browser, or blocked scope — log for debug, don't crash.
    console.warn("serviceWorker.register failed", e?.message || e);
    return null;
  }
}

export async function subscribePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Push not supported");
  }
  const reg = await navigator.serviceWorker.ready;
  const existing = await reg.pushManager.getSubscription();
  if (existing) {
    await api.post("/push/subscribe", {
      endpoint: existing.endpoint,
      keys: {
        p256dh: btoa(String.fromCharCode(...new Uint8Array(existing.getKey("p256dh")))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""),
        auth: btoa(String.fromCharCode(...new Uint8Array(existing.getKey("auth")))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""),
      },
    });
    return existing;
  }
  const { data } = await api.get("/push/vapid-public-key");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlB64ToUint8Array(data.public_key),
  });
  await api.post("/push/subscribe", {
    endpoint: sub.endpoint,
    keys: {
      p256dh: btoa(String.fromCharCode(...new Uint8Array(sub.getKey("p256dh")))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""),
      auth: btoa(String.fromCharCode(...new Uint8Array(sub.getKey("auth")))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""),
    },
  });
  return sub;
}

export async function unsubscribePush() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api.delete(`/push/subscribe?endpoint=${encodeURIComponent(sub.endpoint)}`);
    await sub.unsubscribe();
  }
}

export async function setReminderHour(hour) {
  await api.put("/user/reminder-hour", { hour });
}

export async function sendTestPush() {
  const { data } = await api.post("/push/test");
  return data;
}
